import { stopMediaLoading } from 'redux/ducks/ui';
import store from 'redux/store';

const csvFileEvent = ({ url, requestSource }: any) => {
  store.dispatch(stopMediaLoading(requestSource || 'default'));
  window.location.href = url;
};

export default csvFileEvent;
